import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';

const FEATURE_FLAG_GUARD_DATA_PROPERTY = 'featureFlagGuard';

export interface WebAngularSharedDataAccessFeatureFlagApiGuardOptions {
  flagname: string;
}

/**
 * A Guard that actives a route based on if a feature flag value is true
 * Use the data property of the route to define the required feature
 * https://stackoverflow.com/a/42721468
 *
 * @example
 *  const routes: Routes = [{
      path: '',
      component: SomeComponent,
      data: {
        featureFlagGuard: {flagname: 'some_flagname'}
      },
      canActivate: [WebAngularSharedDataAccessFeatureFlagApiGuard]
 *  }];
 * @export
 * @class WebAngularSharedDataAccessFeatureFlagApiGuard
 * @implements {CanActivate}
 */
@Injectable()
export class WebAngularSharedDataAccessFeatureFlagApiGuard implements CanActivate {
  constructor(private featureFlagsService: WebAngularSharedDataAccessFeatureFlagApisService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const options = route.data[FEATURE_FLAG_GUARD_DATA_PROPERTY] as WebAngularSharedDataAccessFeatureFlagApiGuardOptions;

    return this.featureFlagsService.getFlagAsync(options.flagname).pipe(
      tap(allowed => {
        if (!allowed && !this.router.navigated) {
          // If we haven't navigated yet, this is a deeplink. Redirect to base
          // if we have navigated, just don't allow this navigation (ie. do nothing)
          this.router.navigate(['/']);
        }
      })
    );
  }
}
